import { useCallback, useRef } from "react"

import { SearchByFacetValueQuery } from "../../generated/graphql"
import { useMixpanel } from "../../hooks/use-mixpanel"
import { appStore } from "../../store/AppStore"
import { DomainName } from "../../utilities/constants"

export const useFacetDetailTracking = ({
  content,
  contentType,
}: {
  content: SearchByFacetValueQuery | undefined
  contentType?: string
}) => {
  const track = useMixpanel()
  const trackOnce = useRef(true)
  const lastRouteIsBackNav = appStore((state) => state.lastRouteIsBackNav)

  return useCallback(async () => {
    if (!content || !trackOnce.current || lastRouteIsBackNav) return
    trackOnce.current = false
    track("content_detail_view", {
      page_type: "SearchFacetCollection",
      content_type: contentType,
      content_container_name: content.searchByFacetValue?.title,
      content_container_id: content.searchByFacetValue?.id,
      content_link:
        DomainName +
        `search/${contentType?.toLowerCase()}/${
          content.searchByFacetValue?.id
        }`,
    })
  }, [content, track, lastRouteIsBackNav, contentType])
}
